import axios from '@/api/axios';

export const getPoDetails = (groupId: string, purchaseOrderId: string) =>
  axios.get(`groups/${groupId}/purchase-orders/${purchaseOrderId}`);
export const getPoAttachments = (groupId: string, purchaseOrderId: string) =>
  axios.get(`groups/${groupId}/purchase-orders/${purchaseOrderId}/attachments`);
export const deletePoAttachment = (
  groupId: string,
  purchaseOrderId: string,
  attachmentId: string
) =>
  axios.delete(`groups/${groupId}/purchase-orders/${purchaseOrderId}/attachments/${attachmentId}`);
